import { Box } from '@mui/material';
import React from 'react';
import type { VideoAsset } from '../../../services/admin/adminBackendServiceVideoLibraryMixin';
import { useEditorSidebar } from './editorSidebarContext';
import VideoLibraryCard from './VideoLibraryCard';
import DeleteConfirmBar from './DeleteConfirmBar';

interface MediaLibraryVideoItemProps {
  video: VideoAsset;
  isNarrow: boolean;
  isDeletable: boolean;
  deleteMessage: string;
  confirming: boolean;
  deleting: boolean;
  deleteError: string | null;
  onRequestDelete: () => void;
  onCancelDelete: () => void;
  onConfirmDelete: () => void;
  onEdit: () => void;
}

/** One video card in the Media tab's list, plus its inline delete-confirm bar when open. */
export default function MediaLibraryVideoItem({
  video,
  isNarrow,
  isDeletable,
  deleteMessage,
  confirming,
  deleting,
  deleteError,
  onRequestDelete,
  onCancelDelete,
  onConfirmDelete,
  onEdit,
}: MediaLibraryVideoItemProps) {
  const { pickTarget, closeSidebar, startVideoDrag, endVideoDrag } = useEditorSidebar();
  const ready = video.status === 'READY';

  return (
    <Box sx={{ width: isNarrow ? undefined : '100%', flexShrink: 0 }}>
      <VideoLibraryCard
        video={video}
        fluid={!isNarrow}
        onPick={
          ready && pickTarget
            ? () => {
                pickTarget.onPick(video.externalId);
                closeSidebar();
              }
            : undefined
        }
        onDragStart={ready ? () => startVideoDrag(video.externalId) : undefined}
        onDragEnd={ready ? endVideoDrag : undefined}
        onEdit={onEdit}
        onDelete={isDeletable ? onRequestDelete : undefined}
      />
      {confirming && (
        <DeleteConfirmBar
          message={deleteMessage}
          deleting={deleting}
          error={deleteError}
          onCancel={onCancelDelete}
          onConfirm={onConfirmDelete}
        />
      )}
    </Box>
  );
}
